module.exports = __webpack_public_path__ + "static/media/Exceeding-expectations.2424f26b.jpg";